import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRouter } from "vue-router"
import { useCache } from './useCache'
import { Notify, Dialog  } from 'vant'
import { getUrlKey } from '@/utils/util'
import { useRequest } from './useRequest'
import { customerService } from "@/utils/getCustomerService"


function fieldMapKey(source, target, fieldKeys) {
    Object.keys(fieldKeys).forEach((key) => {
        if (Array.isArray(fieldKeys[key])) {
            fieldKeys[key].map((keyName, keyIndex) => {
                if (source[keyName]) {
                    target[key] += source[keyName] + (keyIndex === fieldKeys[key].length - 1 ? '' : '/')
                }
            })
        } else {
            if (key === 'tel' && source[key] === '') {
                // 门店电话为空时, 将老板电话作为门店电话显示
                if (source['bossPhone']) {
                    target[fieldKeys[key]] = source['bossPhone']
                }
            } else {
                if (Array.isArray(target[fieldKeys[key]])) {
                    if (Array.isArray(source[key])) {
                        if (source[key].length > 0) {
                            source[key].map((imgUrl) => {
                                target[fieldKeys[key]].push({ url: imgUrl })
                            })
                        }
                    } else {
                        if (source[key]) {
                            target[fieldKeys[key]].push({url: source[key]})
                        }
                    }
                } else {
                    target[fieldKeys[key]] = source[key]
                }
            }
        }
    })
}

function setPickerTimeValue(pickerColumns) {
    for (let i = 0; i < 24; i++) {
        pickerColumns[2].values.push({
            text: `${i < 10 ? '0' + i : i }: 00`,
            disabled: false
        })
    }

    pickerColumns[3] = pickerColumns[2]
}

export function useFieldForm() {
    let phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
    let telReg = /^(?:(?:\d{3}-?)?\d{8}|^(?:\d{4}-?)?\d{7,8})(?:-\d+)?$/

    const { proxy } = getCurrentInstance()
    const { getCache, removeCache, setCache } = useCache()
    const router = useRouter()
    const { useApi } = useRequest()
    const showProxySale = ref(false)
    const resdisabled = ref(false)
    const isRegrster = ref(1)
    const showPicker = ref(false)
    const picker = ref(null)
    const showVanPopup = ref(false)
    const storeData = reactive({})
    const showMap = ref(false)

    const pickerColumns = [
        {
            values: [
                {
                    text: '周一',
                    disabled: false
                },
                {
                    text: '周二',
                    disabled: false
                },
                {
                    text: '周三',
                    disabled: false
                },
                {
                    text: '周四',
                    disabled: false
                },
                {
                    text: '周五',
                    disabled: false
                },
                {
                    text: '周六',
                    disabled: false
                },
                {
                    text: '周日',
                    disabled: false
                }
            ],
            defaultIndex: 0
        },
        {
            values: [
                {
                    text: '周一',
                    disabled: false
                },
                {
                    text: '周二',
                    disabled: false
                },
                {
                    text: '周三',
                    disabled: false
                },
                {
                    text: '周四',
                    disabled: false
                },
                {
                    text: '周五',
                    disabled: false
                },
                {
                    text: '周六',
                    disabled: false
                },
                {
                    text: '周日',
                    disabled: false
                }
            ],
            defaultIndex: 0
        },
        {
            values: [],
            defaultIndex: 0
        },
        {
            values: [],
            defaultIndex: 0
        }
    ]

    setPickerTimeValue(pickerColumns)

    let submitFormData = {
        address: '',
        albumImage: '',
        areaId: '',
        areaName: '',
        bannerImage: '',
        bossName: '',
        bossPhone: '',
        cityId: '',
        cityName: '',
        coverImage: '',
        id: 154,
        invitationCode: '',
        licenseImage: '',
        name: '',
        provinceId: '',
        provinceName: '',
        remark: '',
        storeLabelList: '',
        tel: '',
        telCode: '',
        tradeTime: '',
        fromAgentName: '',
        fromBrandName: '',
        position: [],
    }

    const fieldKeyMap = {
        address: 'fullAddress',
        albumImage: 'storeBanners',
        bannerImage: 'banners',
        bossName: 'bossName',
        bossPhone: 'bossPhone',
        coverImage: 'storeLOGO',
        licenseImage: 'license',
        name: 'storeName',
        remark: 'remark',
        storeLabelList: 'labels',
        tel: 'phone',
        tradeTime: 'businessHours',
        areaCode: ['provinceName', 'cityName', 'areaName'],
        fromAgentName: 'proxySaleName',
        fromBrandName: 'proxySaleBrand',
        position: 'position',
        invitationCode: 'invitationCode'
    }

    const fieldForm = reactive({
        proxySaleName: '',
        proxySaleBrand: '',
        areaCode: '',
        bossName: '',
        bossPhone: '',
        storeName: '',
        phone: '',
        fullAddress: '',
        storeLOGO: [],
        license: [],
        labels: '',
        businessHours: '',
        remark: '',
        banners: [],
        storeBanners: [],
        position: [],
        invitationCode: ''
    })

    onMounted(() => {
        if (getUrlKey('linkCode')) {
            showProxySale.value = true  // 公域链接
        }

        let formData = getCache('submitFormData')
        const code = getUrlKey('code')
        if (code == formData.invitationCode) {
            submitFormData = formData
            fieldMapKey(formData, fieldForm, fieldKeyMap)
        } else {
            removeCache('submitFormData')
            setFieldValue('invitationCode', code)
            //
        }
        //  && formData.id
        // if (formData && formData.id) {
        //     submitFormData = formData
        //     fieldMapKey(formData, fieldForm, fieldKeyMap)
        // }
        // removeCache('storeData')
    })

    const verifyStore = async(phone, storeName) => {
        if (!phone && !storeName) return
        if (phone && !phoneReg.test(phone)) {
            // console.log('verifyStore', phone)
            return
        }

        let params = {}
        if (phone) params['bossPhone'] = phone
        if (storeName) params['name'] = storeName

        try {
            let { result } = await useApi({
                url: '/store_settled/add_verify',
                method: 'post',
            }, params)

            if (result.success) {
                let data = result.data
                if (data && data.id) {
                    Object.assign(storeData, data)
                    showVanPopup.value = true
                }
            } else {
                console.log('verifyStore', result)
            }
        } catch (error) {
            console.log('verifyStore', error)
        }
    }

    const onPickerChange = (weekPicker, pickerRowIndex) => {
        let { text } = weekPicker[pickerRowIndex]
        const week = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
        let weekIndex = week.findIndex((item) => item === text)
        pickerColumns[1].defaultIndex = weekIndex

        if (pickerRowIndex === 0) {
            let pickerValue = pickerColumns[1].values.map((item, index) => {
                if (index < weekIndex) {
                    item.disabled = true
                } else {
                    item.disabled = false
                }

                return item
            })

            picker.value.setColumnValues(1, pickerValue)
        }

        if (pickerRowIndex === 2) {
            let pickerValues = pickerColumns[2].values.map((item) => item.text)
            let tiemIndex = pickerValues.findIndex((item) => item === text)

            let pickerValue = pickerColumns[3].values.map((item, index) => {
                if (index < tiemIndex) {
                    item.disabled = true
                } else {
                    item.disabled = false
                }

                return item
            })

            picker.value.setColumnValues(3, pickerValue)
        }
    }

    const onPickerConfirm = (value) => {
        let [weekBegin, weekStop, timeBegin, timeStop] = value
        let tradeTime = `${weekBegin.text}至${weekStop.text} ${timeBegin.text}-${timeStop.text}`
        fieldForm.businessHours = tradeTime
        showPicker.value = false
        setFieldValue('tradeTime', tradeTime)
    }

    const setFieldValue = (fieldKey, fieldValue) => {
        if (fieldKey === 'bossPhone' && fieldValue && !phoneReg.test(fieldValue)) {
            return proxy.$toast('手机号码格式有误')
        }

        if (fieldKey === 'tel' && fieldValue && !phoneReg.test(fieldValue) && !telReg.test(fieldValue)) {
            return proxy.$toast('门店电话格式有误')
        }

        if (fieldKey === 'name') {
            verifyStore(fieldForm.bossPhone, fieldValue)
        }

        if (fieldKey !== '') {
            let formData = getCache('submitFormData')

            if (formData) {
                if (Array.isArray(fieldKey) && Array.isArray(fieldValue)) {
                    fieldKey.map((key, index) => {
                        formData[key] = fieldValue[index]
                    })
                } else {
                    if (formData[fieldKey] === fieldValue) return
                    formData[fieldKey] = fieldValue
                }

                setCache('submitFormData', formData)
            } else {
                if (Array.isArray(fieldKey) && Array.isArray(fieldValue)) {
                    fieldKey.map((key, index) => {
                        submitFormData[key] = fieldValue[index]
                    })
                } else {
                    submitFormData[fieldKey] = fieldValue
                }

                setCache('submitFormData', submitFormData)
            }

            if (fieldValue !== '' && fieldKey!== 'invitationCode') {
                Notify({
                    color: '#0F50C5',
                    background: '#f4f7ff',
                    duration: 1000,
                    message: '已自动保存信息下次进入可继续填写，确认后点击提交开店'
                })
            }
        }
    }

    const openService = () => {
        Dialog({
            title: '提示',
            message: '是否需要联系客服？',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonColor: '#3363DE',
            cancelButtonColor: '#C7C7C7',
        }).then( async () => {
            try {
                let { result } = await useApi({
                    url: '/base/kefu',
                    method: 'post'
                }, { id: 0, AdCode: '' })
                if (result.success) {
                    customerService(result.data)
                } else {
                    proxy.$toast(result.errorMessage)
                }
                } catch (error) {
                    console.log('getWechatUrlLink', error)
                }
        })
        .catch(() => {
            proxy.$toast('已取消')
        });

    }

    const submitUserData = async(smsCode, msgCodeStatus) => {
        let formData = getCache('submitFormData') || submitFormData
        formData.applyFrom = showProxySale.value ? 3 : 1
        formData.telCode = smsCode
        const verifyData = {}

        const verifyRules = [
            {
                verifyKey: 'bossName',
                title: '请填写店老板姓名'
            },
            {
                verifyKey: 'bossPhone',
                title: '请填写店老板电话'
            },
            {
                verifyKey: 'telCode',
                title: '请填写手机验证码'
            },
            {
                verifyKey: 'name',
                title: '请填写门店名称'
            },
            {
                verifyKey: 'areaName',
                title: '请填写门店地址'
            },
            {
                verifyKey: 'address',
                title: '请填写门店详细地址'
            },
            {
                verifyKey: 'coverImage',
                title: '请上传门店LOGO'
            },
            {
                verifyKey: 'licenseImage',
                title: '请上传营业执照'
            }
        ]
        for (let rule of verifyRules) {
            if (!formData[rule['verifyKey']]) {
                verifyData.title = rule.title
                break
            }
        }

        if (verifyData.title) {
            return proxy.$toast(verifyData.title)
        }

        formData.invitationCode = getUrlKey('code') ? getUrlKey('code') : null
        if (!msgCodeStatus || formData.telCode.length !== 6) {
            return proxy.$toast('手机验证码有误')
        }

        if (fieldForm.phone) {
            if (!phoneReg.test(fieldForm.phone) && !telReg.test(fieldForm.phone)) {
                proxy.$toast({
                    message: '门店电话格式有误',
                    duration: 1000,
                })

                return
            }
        } else {
          formData.tel = formData.bossPhone
        }
        formData.albumImage = formData.albumImage || []
        formData.bannerImage = formData.bannerImage || []
        formData.storeLabelList = formData.storeLabelList || []
        formData.applyFrom = showProxySale.value ? 3 : 1
        formData.lat= formData.position[1] + '' || ''
        formData.lng= formData.position[0] + '' || ''
        resdisabled.value = true

        try {
            let { result } = await useApi({
                url: '/store_settled/add',
                method: 'post',
            }, formData)

            if (result.success) {
                removeCache('submitFormData')  // 提交后移除本地缓存的表单数据
                if (result.data && result.data.name) {
                    let storeData = result.data
                    setTimeout(() => {
                        router.push({
                            name: 'open-result',
                            params: {
                                storeInfo: JSON.stringify(storeData),
                                // sourceType: getUrlKey('regCode') === '2' ? 'app' : 'h5'
                                sourceType: 'app'
                            }
                        })
                    }, 1000)
                }
            } else {
                proxy.$toast({
                    message: result.errorMessage,
                    duration: 1500,
                })
            }
        } catch (error) {
            console.log('submitUserData', error)
        } finally {
            resdisabled.value = false
        }
    }

    return {
        fieldForm,
        setFieldValue,
        submitUserData,
        onPickerChange,
        onPickerConfirm,
        verifyStore,
        openService,
        resdisabled,
        isRegrster,
        showPicker,
        pickerColumns,
        picker,
        showProxySale,
        showVanPopup,
        storeData,
        showMap
    }
}
